import { getPointStatus } from "@components/Listings/DealScore/utils"
import { Listing } from "@t/Listing"
import { StatItem } from "@components/Listings/DealScoreDialog/StatItem"
import Image from "next/image"
import MoneyIcon from "@components/Listings/DealScoreDialog/icons/Money Box.png"

export function UsablePointsStatItem({ listing }: { listing: Listing }) {
    const status = getPointStatus(listing)
    let part1 = undefined
    let part2 = <>Our algorithm factors this into the ranking and is appropriately adjusted to consider the advertised price-per-point.</>
    switch (status) {
        case "Loaded":
            part1 = (
                <>
                    This listing is <strong>“Loaded”</strong> meaning that the current owner banked extra points from a previous use-year into either the current or next use-year.
                    In this case, the listing <strong>has {Math.abs(listing.initial_point_variation)} more usable points</strong> than you’d you’d expect for an{" "}
                    {listing.points_on_contract} point contract.
                </>
            )
            break
        case "Some extra":
            break
        case "Normal":
            part1 = (
                <>
                    This listing has a <strong>“Normal”</strong> contract point status meaning that it <strong>has all {listing.points_on_contract} points available</strong> to use
                    in both the current and future use years.
                </>
            )
            break
        case "":
            break
        case "Stripped":
            part1 = (
                <>
                    This listing is <strong>“Fully Stripped”</strong> meaning that every point for the current or following “use-year” have already been used by the current owner.
                    In this case, it <strong>has {Math.abs(listing.initial_point_variation)} fewer usable points</strong> than you’d expect for an untouched{" "}
                    {listing.points_on_contract} point contract.
                </>
            )
            break
        case "Partially stripped":
            part1 = (
                <>
                    This listing is <strong>“Partially Stripped”</strong>meaning that some points for the current or following “use-year” have already been used by the current
                    owner. In this case, it <strong>has {Math.abs(listing.initial_point_variation)} fewer usable points</strong> than you’d expect for an untouched{" "}
                    {listing.points_on_contract} point contract.
                </>
            )
            break
        default:
            break // Handle default case if needed
    }
    return (
        <StatItem image={<Image src={MoneyIcon} alt="Usable Points" width={40} height={40} />} imgText="Usable Points">
            {part1} {part2}
        </StatItem>
    )
}
